import React from 'react';
import { environment } from '@/config/environment';

interface NetworkSwitchDialogProps {
  isOpen: boolean;
  onSwitchNetwork: () => Promise<void>;
  onClose: () => void;
}

export const NetworkSwitchDialog: React.FC<NetworkSwitchDialogProps> = ({
  isOpen,
  onSwitchNetwork,
  onClose,
}) => {
  const [isSwitching, setIsSwitching] = React.useState(false);

  if (!isOpen) return null;

  const handleSwitch = async () => {
    setIsSwitching(true);
    try {
      await onSwitchNetwork();
    } catch (error) {
      console.error('Failed to switch network:', error);
    } finally {
      setIsSwitching(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm" role="dialog" aria-modal="true" aria-labelledby="network-dialog-title">
      <div className="glass-effect border border-primary/20 rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex items-center justify-center w-16 h-16 bg-yellow-500/20 rounded-full mb-6 mx-auto">
          <svg className="w-8 h-8 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
        </div>
        
        <h2 id="network-dialog-title" className="text-2xl font-bold text-gradient-primary mb-3 text-center">Wrong Network</h2>
        <p className="text-gray-400 mb-6 text-center">
          Please switch to <span className="text-primary font-semibold">{environment.chainName}</span> to use this application.
        </p>

        <div className="bg-dark-lighter border border-primary/10 rounded-xl p-4 mb-6">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-500">Required Network:</span>
            <span className="text-sm font-semibold text-primary">{environment.chainName}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-500">Chain ID:</span>
            <span className="text-sm font-mono text-gray-300">{environment.chainId}</span>
          </div>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={handleSwitch}
            disabled={isSwitching}
            className="flex-1 px-6 py-3 bg-primary hover:bg-primary-light text-dark font-bold rounded-xl transition-all duration-200 shadow-lg shadow-primary/20 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSwitching ? 'Switching...' : 'Switch Network'}
          </button>
          <button
            onClick={onClose}
            disabled={isSwitching}
            className="px-6 py-3 glass-effect border border-gray-600 hover:border-gray-500 text-gray-300 font-semibold rounded-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
